/* eslint-disable react/self-closing-comp */
import React, { useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useLazyQuery } from '@apollo/client';
import { Message, Form, Button, Header, Loader } from 'semantic-ui-react';
// material
import { styled } from '@mui/material/styles';
import { Container } from '@mui/material';

import FORM_TEXT from '../components/common/errors/FormYupFormik';
import MyTextInput from '../components/common/form/MyTextInput';

import { getComplaint } from '../graphql/queries';
import ConplaintView from '../components/complaint/ComplaintView';

// Menu
import Menu from '../components/Menu';
import ClientMenuLeft from './common/ClientMenuLeft';
// components
import Page from '../components/Page';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 900,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function ClientSearchPage() {
  const [confirmation, setConfirmation] = useState(null);

  const initialValues = {
    confirmation: ''
  };

  const validationSchema = Yup.object().shape({
    confirmation: Yup.string().required(FORM_TEXT.REQUIRED_FR)
  });

  const [retrieveComplaint, { loading, data, error }] = useLazyQuery(getComplaint);

  const handleSubmit = (values, { resetForm }) => {
    retrieveComplaint({
      variables: {
        confirmation: values.confirmation
      }
    });
    setConfirmation(values.confirmation);
    resetForm();
  };

  const handleOnKeyUp = () => {
    setConfirmation(null);
  };
  return (
    <RootStyle title="Register | Gestion des plaintes">
      <Menu />
      <ClientMenuLeft />

      <Container>
        <ContentStyle>
          {error && (
            <Message negative>
              <Message.Header>Erreur Technique</Message.Header>
              <p>{error}</p>
            </Message>
          )}

          <Message>
            <Header as="h2" color="blue">
              Retrouver votre plainte
            </Header>
          </Message>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ handleSubmit }) => (
              <Form className="attached fluid segment" size="large" onSubmit={handleSubmit}>
                <Form.Field>
                  <MyTextInput
                    name="confirmation"
                    placeholder="Réference de confirmation"
                    onKeyUp={handleOnKeyUp}
                  />
                </Form.Field>
                {loading && <Loader active inline="centered" />}
                {!loading && (
                  <Button.Group>
                    <Button fluid type="submit" positive content="Rechercher" />
                  </Button.Group>
                )}
              </Form>
            )}
          </Formik>

          {data && data.getComplaint ? (
            <ConplaintView complaint={data.getComplaint} />
          ) : (
            <>
              {confirmation && (
                <Message error>
                  <Message.Header>Cette plainte n'existe pas</Message.Header>
                </Message>
              )}
            </>
          )}
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
